import type { FaireReviewEntity } from "../../entity_types/review";

export const review_r2: FaireReviewEntity = {
  token: "review_r2",
  type: "review",
  brandName: "ROEN",
  reviewerName: "James L.",
  reviewerLocation: "Brooklyn, NY",
  stars: 5,
  reviewText:
    "Best wholesale candle brand I've carried. The quality is consistent and my customers love the minimalist aesthetic.",
  reviewDate: "Jan 8, 2026",
  reviewType: "product",
  purchasedProductImageUrls: [
    "https://cdn.prerelease.faire.dev/fastly/59a4005712dbc289690cccb048ed1838bfbb32630127b5ae4ce805f9204e0b93.webp",
  ],
  productImageUrl:
    "https://images.unsplash.com/photo-1599446220456-d2438c8867e6?w=80&h=80&fit=crop",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
